import { AnnouncementBar, Header } from '@/components/Header';
import { Hero } from '@/components/Hero';
import { Marquee } from '@/components/Marquee';
import { Spotlight } from '@/components/Spotlight';
import { Steps } from '@/components/Steps';
import { ProductDetail } from '@/components/ProductDetail';
import { Surfaces } from '@/components/Surfaces';
import { Reviews } from '@/components/Reviews';
import { Faq } from '@/components/Faq';
import { Compliance } from '@/components/Compliance';
import { FinalCta } from '@/components/FinalCta';
import { Footer } from '@/components/Footer';

export default function Home() {
  return (
    <div className="bg-brand-cream text-brand-green font-sans antialiased selection:bg-brand-orange selection:text-white min-h-screen">
      <div className="noise-overlay" aria-hidden="true" />
      <AnnouncementBar />
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Spotlight />
        <Steps />
        <ProductDetail />
        <Surfaces />
        <Reviews />
        <Faq />
        <Compliance />
        <FinalCta />
      </main>
      <Footer />
    </div>
  );
}
